import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D7C0D37A-BF75-4542-8AFF-614FA0EC498C
 * name keyboard-tab
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-tab.svg
 * tags
 */
export const KeyboardTabIcon = createSvgIcon(<><path d="M20,18H22V6H20M11.59,7.41L15.17,11H1V13H15.17L11.59,16.58L13,18L19,12L13,6L11.59,7.41Z" /></>, 'KeyboardTabIcon');
export default KeyboardTabIcon